const scrollThresholds = {
  triggerRem: 4,
  targetRem: 2,
};

function remToPx(rem) {
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  return rem * rootFontSize;
}

if (!customElements.get('horizontal-accordion-component')) {
  customElements.define(
    'horizontal-accordion-component',
    class HorizontalAccordion extends HTMLElement {
      constructor() {
        super();

        this.onTabClick = this.onTabClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onTabClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onTabClick);
      }

      async onTabClick(event) {
        const tab = event.target.closest('.accordion-tab');

        if (!tab || !window.theme.isMobile) return;

        const input = document.getElementById(tab.getAttribute('for'));

        if (!input || input.checked) return;

        event.preventDefault();

        await this.scrollTabIntoView(tab);

        input.checked = true;
      }

      scrollTabIntoView(tab) {
        const top = tab.getBoundingClientRect().top;

        if (top <= remToPx(scrollThresholds.triggerRem)) return Promise.resolve();

        return new Promise((resolve) => {
          window.addEventListener('scrollend', resolve, { once: true });

          window.scrollBy({ top: top - remToPx(scrollThresholds.targetRem), behavior: 'smooth' });
        });
      }
    }
  );
}
